import { render, staticRenderFns } from "./CriarArtigo.vue?vue&type=template&id=60909812&"
import script from "./CriarArtigo.vue?vue&type=script&lang=js&"
export * from "./CriarArtigo.vue?vue&type=script&lang=js&"
import style0 from "./CriarArtigo.vue?vue&type=style&index=0&id=60909812&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports